import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MissionDetail from '../components/MissionDetail';
import { useMissionContext } from '../context/MissionContext';
import apiService from '../services/apiService';

export default function MissionDetailPage() {
  const { missionId } = useParams();
  const { missions, isLoading: listLoading } = useMissionContext();
  const navigate = useNavigate();

  const listMission = missions.find((m) => String(m.id) === String(missionId));
  const [mission, setMission] = useState(listMission || null);
  const [detailLoading, setDetailLoading] = useState(true);
  const [offlineHint, setOfflineHint] = useState(false);

  useEffect(() => {
    if (listMission) {
      setMission((prev) => ({ ...(prev || {}), ...listMission, ...(prev?.machines ? { machines: prev.machines } : {}) }));
    }
  }, [listMission]);

  useEffect(() => {
    let cancelled = false;

    const loadDetail = async () => {
      if (!missionId) {
        setDetailLoading(false);
        return;
      }
      setDetailLoading(true);
      setOfflineHint(false);

      const res = await apiService.getMissionDetails(missionId);
      if (cancelled) return;

      if (res?.success && res.data) {
        setMission((prev) => ({
          ...(prev || {}),
          ...res.data,
          // Conserver meta locale (numéro rapport affichable) si absente du détail
          numero_rapport: res.data.rapport?.numero
            || prev?.numero_rapport
            || res.data.numero_rapport,
          rapport_meta: prev?.rapport_meta,
        }));
      } else if (listMission) {
        setMission(listMission);
        setOfflineHint(true);
      } else {
        setMission(null);
      }
      setDetailLoading(false);
    };

    loadDetail();
    return () => { cancelled = true; };
  }, [missionId]); // eslint-disable-line react-hooks/exhaustive-deps -- listMission géré à part

  const onBack = () => {
    navigate('/missions');
  };

  const onGoHome = () => {
    navigate('/');
  };

  const onStartInspection = (m, inspectionType) => {
    const id = encodeURIComponent(m.id);
    if (inspectionType === 'levage') {
      navigate(`/mission/${id}/inspection/levage`);
    } else if (inspectionType === 'thermographie') {
      navigate(`/mission/${id}/inspection/thermo`);
    } else {
      navigate(`/mission/${id}/inspection`);
    }
  };

  if ((listLoading || detailLoading) && !mission) {
    return (
      <div className="app">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column',
            gap: '20px',
          }}
        >
          <div className="spinner-large"></div>
          <p>Chargement de la fiche…</p>
        </div>
      </div>
    );
  }

  if (!mission) {
    return (
      <div className="app" style={{ padding: '24px', textAlign: 'center' }}>
        <p style={{ marginBottom: '16px', color: '#334155' }}>Mission introuvable.</p>
        <button
          type="button"
          className="sync-button"
          onClick={() => navigate('/missions')}
          style={{ padding: '10px 20px' }}
        >
          Retour aux missions
        </button>
      </div>
    );
  }

  return (
    <div className="app">
      <MissionDetail
        mission={mission}
        offlineHint={offlineHint}
        detailLoading={detailLoading}
        onBack={onBack}
        onGoHome={onGoHome}
        onStartInspection={onStartInspection}
      />
    </div>
  );
}
